import React from 'react'


import { Badge, classnames } from '@cgtrader/triangle-ui/dist/src/ssr-index'
import { object, bool } from 'prop-types'

import { EMPTY_OBJECT } from 'Utils/stableDefaults'

const shortTypeLabels = {
  printReady: '3D Print',
  animated: 'Anim',
  pbr: 'PBR',
  rigged: 'Rig',
  lowPoly: 'L-Poly',
}

function ModelCardTypeTags({
  types = EMPTY_OBJECT, isVisible, hidePrintReady = false,
}) {
  let activeTypes = Object.keys(types).filter(type => types[type])

  if (hidePrintReady) {
    activeTypes = activeTypes.filter(type => type !== 'printReady')
  }

  if (!activeTypes.length) return null

  return (
    <div className={classnames(
      'card-3d-model__type-tags',
      isVisible && 'card-3d-model__type-tags--visible',
    )}
    >
      {activeTypes.map(type => (
        <Badge type="white" hasBorder key={type}>{shortTypeLabels[type]}</Badge>
      ))}
    </div>
  )
}

ModelCardTypeTags.propTypes = {
  types: object,
  isVisible: bool.isRequired,
  hidePrintReady: bool,
}

export default ModelCardTypeTags
